var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-box"},[_c('div',{staticClass:"one-title"},[_vm._v("城市铺设规模")]),_vm._v(" "),_c('div',{staticClass:"one-part-box"},[_c('div',{ref:"citySale",staticStyle:{"width":"100%","height":"104%"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe82484","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/moudles/CitySaleMoudle.vue
// module id = null
// module chunks = 